/* eslint-disable jsx-a11y/label-has-associated-control */
import CheckIcon from '@svg/check.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './CheckboxInput.module.scss';

function CheckboxInput({
  groupCheckbox,
  onChange,
  children,
  modifier,
  required,
  checked,
  label,
  value,
  error,
  name,
  id,
}) {
  return (
    <div
      key={id}
      className={classNames(
        styles.checkbox,
        groupCheckbox && styles.groupCheckbox,
        error && styles.error,
        styles[modifier]
      )}
    >
      <input
        className={classNames(styles.input, 'u-visually-hidden')}
        required={required}
        onChange={onChange}
        checked={checked}
        type="checkbox"
        value={value}
        name={name}
        id={id}
      />
      <label
        htmlFor={id}
        className={classNames(
          styles.labelWrapper,
          groupCheckbox && styles.groupCheckbox
        )}
      >
        <span className={styles.indicator}>
          <CheckIcon className={styles.icon} />
        </span>
        <span
          className={classNames(styles.label)}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: `${label}${required ? '*' : ''}` }}
        />
      </label>
      {children && <div className={styles.checkboxContent}>{children}</div>}
    </div>
  );
}

CheckboxInput.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  modifier: PropTypes.string,
  error: PropTypes.bool,
  groupCheckbox: PropTypes.bool,
  children: PropTypes.node,
};

export default CheckboxInput;
